import React from 'react';
interface OrnamentDividerProps {
  className?: string;
}
export function OrnamentDivider({
  className = ''
}: OrnamentDividerProps) {
  return <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true" data-id="element-42" data-mp="28yj17jys18zd">
      <span className="h-px w-12 bg-current opacity-60" data-id="element-43" data-mp="2dw1etnnqocdp" />
      <span className="h-1 w-1 rotate-45 bg-current opacity-60" data-id="element-44" data-mp="2ioccejv0bm33" />
      <span className="h-2.5 w-2.5 rotate-45 border border-current" data-id="element-45" data-mp="2nn5ruhtutn5w" />
      <span className="h-1 w-1 rotate-45 bg-current opacity-60" data-id="element-46" data-mp="2nmvzwop915xk" />
      <span className="h-px w-12 bg-current opacity-60" data-id="element-47" data-mp="2rnzcn2c02luk" />
    </div>;
}